import { render } from "./list-receivable-account.vue?vue&type=template&id=6a60d876"
import script from "./list-receivable-account.vue?vue&type=script&lang=js"
export * from "./list-receivable-account.vue?vue&type=script&lang=js"

import "./list-receivable-account.vue?vue&type=style&index=0&id=6a60d876&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__